var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"card"},[_c('div',{staticClass:"card__inner"},[(_vm.closable)?_c('a',{staticClass:"card__close",on:{"click":function($event){return _vm.$emit('cardClosed')}}},[_vm._v("×")]):_vm._e(),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }